/**
 * Tuning knobs for Battle Arena. Draft shape, run length, and how often a
 * legendary single upgrades to a Mythic. Trio packages themselves live in
 * `arena-combos.ts`.
 */

/** Wins needed to complete an Arena run. */
export const ARENA_WINS_TO_COMPLETE = 3;
/** Losses that end an Arena run. */
export const ARENA_MAX_LOSSES = 2;
/** Named trio packages shown on a trio pick. */
export const ARENA_TRIO_OPTIONS = 2;
/** Badges shown on a single pick. */
export const ARENA_SINGLE_OPTIONS = 4;
/** Chance a legendary single slot upgrades to a Mythic. */
export const ARENA_MYTHIC_CHANCE = 0.33;

export const ARENA_SCHEDULE = ['trio', 'single', 'single', 'single', 'trio', 'single', 'single', 'single'] as const;
export type ArenaPickKind = (typeof ARENA_SCHEDULE)[number];
